import { render, staticRenderFns } from "./QRPortrait.vue?vue&type=template&id=90850f26&scoped=true"
import script from "./QRPortrait.vue?vue&type=script&lang=js"
export * from "./QRPortrait.vue?vue&type=script&lang=js"
import style0 from "./QRPortrait.vue?vue&type=style&index=0&id=90850f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90850f26",
  null
  
)

export default component.exports